<template>
  <div id="app">
    <nav-ber></nav-ber>
    <transition name="fade">
      <router-view />
    </transition>
    <Footer />
    <el-backtop class="min">
      <div>
        <img style="width: 100%;height: 100%;"
             src="./assets//椭圆 4@2x.png"
             alt="">
      </div>
    </el-backtop>
  </div>
</template>
<script>
import NavBer from "@/components/NavBer";
import Footer from "@/components/footer";
export default {
  components: {
    NavBer,
    Footer,
  },
};
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.fade-leave,   // 离开前,进入后透明度是1
.fade-enter-to {
  opacity: 1;
}
.fade-leave-active,
.fade-enter-active {
  transition: all 0.3s; //过度是2秒
}
.fade-leave-to,
.fade-enter {
  opacity: 0;
}
@media (min-width: 1024px) {
  .min {
    width: 70px !important;
    height: 70px !important;
    div {
      width: 30px;
      height: 30px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
@media (max-width: 1024px) {
  .min {
    width: 40px;
    height: 40px;
    div {
      width: 20px;
      height: 20px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
